import { ObjectSchema, bool, object, string } from 'yup';
import { ErrorMessage, Product } from '../enums';
import { useRoute } from '../hooks';
import { ReviewFormValues } from '../types/form';
import { NS_ERROR } from '@/i18n/namespaces';
import { useTranslation } from 'react-i18next';

export const useReviewSchema = () => {
  const { product } = useRoute();
  const { t } = useTranslation(NS_ERROR);
  const isEasyHealth = product === Product.EasyHealth;

  const reviewSchema: ObjectSchema<ReviewFormValues> = object({
    confirmation: object({
      covered: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      uncovered: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      changeOfMind: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
    }).required(),

    declaration: object({
      agreed: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      acknowledged: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      understood: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      assessed: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
      debitCredit: bool()
        .default(isEasyHealth)
        .isTrue(ErrorMessage.Required)
        .required(ErrorMessage.Required),
    }).required(),

    marketingConsent: bool().default(false).optional(),

    promoCode: string()
      .transform((value) => (typeof value === 'string' ? value.trim() : value))
      .optional()
      .test('empty-or-constraints', '', (value) => {
        return true;
      })
      .min(3, t(ErrorMessage.MinLength, '', { min: 3 }))
      .max(30, t(ErrorMessage.MaxLength, '', { max: 30 }))
      .matches(/^[A-Z0-9 ]+$/, { message: ' ', excludeEmptyString: true })
      .matches(/[A-Z]/, { message: ' ', excludeEmptyString: true }),
  });

  return { reviewSchema };
};
